import request from "../services/HTTPClient";
import { requestMethods, API } from "../constants";

function createCategory(categoryData) {
  return request({
    url: API.MARKETPLACE.CATEGORIES.CREATE,
    method: requestMethods.POST,
    data: categoryData,
  });
}

function updateCategory(categoryId, categoryData) {
  return request({
    url: `${API.MARKETPLACE.CATEGORIES.CREATE}/${categoryId}`,
    method: requestMethods.PUT,
    data: categoryData,
  });
}

function getCategories() {
  return request({
    url: API.MARKETPLACE.CATEGORIES.GET_ALL,
    method: requestMethods.GET,
  });
}

function getSubcategoriesByCategory(categorySlug) {
  return request({
    url: `${API.MARKETPLACE.CATEGORIES.GET_SUBCATEGORIES}?parent=${categorySlug}`,
    method: requestMethods.GET,
  });
}

function deleteCategoryBySlug(slug) {
  return request({
    url: `product-categories/${slug}`,
    method: requestMethods.DELETE,
  });
}
// ==================== PRODUCTOS ====================

function newProduct(body) {
  return request({
    url: API.MARKETPLACE.PRODUCTS.NEW,
    method: requestMethods.POST,
    data: body,
  });
}

function updateProduct(body, id) {
  return request({
    url: API.MARKETPLACE.PRODUCTS.UPDATE.concat(id),
    method: requestMethods.PUT,
    data: body,
  });
}

function deleteProduct(product_id) {
  return request({
    url: API.MARKETPLACE.PRODUCTS.DELETE.concat(product_id),
    method: requestMethods.DELETE,
  });
}

function getAllProducts() {
  return request({
    url: API.MARKETPLACE.PRODUCTS.GET_ALL,
    method: requestMethods.GET,
  });
}

function filterProducts(categorySlug = null, subcategorySlug = null) {
  const params = new URLSearchParams();
  if (categorySlug) params.append("category", categorySlug);
  if (subcategorySlug) params.append("subcategory", subcategorySlug);
  return request({
    url: `${API.MARKETPLACE.PRODUCTS.FILTER}?${params.toString()}`,
    method: requestMethods.GET,
  });
}

function getProductById(id) {
  return request({
    url: API.MARKETPLACE.PRODUCTS.GET_BY_ID.concat(id),
    method: requestMethods.GET,
  });
}

function getProductsByCategory(categorySlug) {
  return request({
    url: API.MARKETPLACE.PRODUCTS.GET_BY_CATEGORY.concat(categorySlug),
    method: requestMethods.GET,
  });
}

function getProductsByCategoryAndSubcategory(categorySlug, subcategorySlug) {
  return request({
    url: `${API.MARKETPLACE.PRODUCTS.GET_BY_CATEGORY_AND_SUBCATEGORY}${categorySlug}&subcategory=${subcategorySlug}`,
    method: requestMethods.GET,
  });
}

function getProductsBySupplier(supplierId) {
  return request({
    url: API.MARKETPLACE.PRODUCTS.GET_BY_SUPPLIER.concat(supplierId),
    method: requestMethods.GET,
  });
}

function searchProducts(searchTerm) {
  return request({
    url: API.MARKETPLACE.PRODUCTS.SEARCH.concat(encodeURIComponent(searchTerm)),
    method: requestMethods.GET,
  });
}
// ==================== ORDERS ====================
function newOrder(body) {
  return request({
    url: API.MARKETPLACE.ORDERS.NEW,
    method: requestMethods.POST,
    data: body,
  });
}

function updateOrder(body, id) {
  return request({
    url: API.MARKETPLACE.ORDERS.UPDATE.concat(id),
    method: requestMethods.PUT,
    data: body,
  });
}

function deleteOrder(id) {
  return request({
    url: API.MARKETPLACE.ORDERS.DELETE.concat(id),
    method: requestMethods.DELETE,
  });
}

function getOrderById(id) {
  return request({
    url: API.MARKETPLACE.ORDERS.GET_BY_ID.concat(id),
    method: requestMethods.GET,
  });
}

function getOrderByClient(id) {
  return request({
    url: API.MARKETPLACE.ORDERS.GET_BY_CLIENT.concat(id),
    method: requestMethods.GET,
  });
}

function getOrderBySupplier(id) {
  return request({
    url: API.MARKETPLACE.ORDERS.GET_BY_SUPPLIER.concat(id),
    method: requestMethods.GET,
  });
}

function updateOrderStatus(orderId, statusData) {
  const url = API.MARKETPLACE.ORDERS.UPDATE + orderId;
  return request({
    url: url,
    method: requestMethods.PUT,
    data: statusData,
  });
}

function getAllOrders() {
  return request({
    url: API.MARKETPLACE.ORDERS.GET_ALL,
    method: requestMethods.GET,
  });
}
// ==================== CART ====================

function addProductToCart(body) {
  return request({
    url: API.MARKETPLACE.CART.ADD_PRODUCT,
    method: requestMethods.POST,
    data: body,
  });
}

function updateCart(body, id) {
  return request({
    url: API.MARKETPLACE.CART.UPDATE.concat(id),
    method: requestMethods.PUT,
    data: body,
  });
}

function deleteCart(id) {
  return request({
    url: API.MARKETPLACE.CART.DELETE.concat(id),
    method: requestMethods.DELETE,
  });
}

function deleteCartProduct(user_id, product_id) {
  return request({
    url: API.MARKETPLACE.CART.DELETE_PRODUCT.concat(user_id + "/" + product_id),
    method: requestMethods.DELETE,
  });
}

function getCartById(id) {
  return request({
    url: API.MARKETPLACE.CART.GET_BY_ID.concat(id),
    method: requestMethods.GET,
  });
}

function getCartByClient(id) {
  return request({
    url: API.MARKETPLACE.CART.GET_BY_CLIENT.concat(id),
    method: requestMethods.GET,
  });
}

function getAllCarts() {
  return request({
    url: API.MARKETPLACE.CART.GET_ALL,
    method: requestMethods.GET,
  });
}
// ==================== LOGS ====================

function getLogsByOrder(id) {
  return request({
    url: API.MARKETPLACE.LOGS.GET_BY_ORDER.concat(id),
    method: requestMethods.GET,
  });
}
// ==================== VENDOR ====================

function addVendor(body) {
  return request({
    url: API.MARKETPLACE.VENDOR.NEW,
    method: requestMethods.POST,
    data: body,
  });
}

function updateVendor(body, id) {
  return request({
    url: API.MARKETPLACE.VENDOR.UPDATE.concat(id),
    method: requestMethods.PUT,
    data: body,
  });
}

function archiveVendor(id) {
  return request({
    url: API.MARKETPLACE.VENDOR.ARCHIVE.concat(id),
    method: requestMethods.PUT,
  });
}

function unarchiveVendor(id) {
  return request({
    url: API.MARKETPLACE.VENDOR.UNARCHIVE.concat(id),
    method: requestMethods.PUT,
  });
}

function deleteVendor(id) {
  return request({
    url: API.MARKETPLACE.VENDOR.DELETE.concat(id),
    method: requestMethods.DELETE,
  });
}

function getAllVendors() {
  return request({
    url: API.MARKETPLACE.VENDOR.GET_ALL,
    method: requestMethods.GET,
  });
}

function getAllVendorsByUser(id) {
  return request({
    url: API.MARKETPLACE.VENDOR.GET_ALL_BY_USER.concat(id),
    method: requestMethods.GET,
  });
}

function getVendorByUser(id) {
  return request({
    url: API.MARKETPLACE.VENDOR.GET_BY_USER.concat(id),
    method: requestMethods.GET,
  });
}

const Products = {
  GetAll: () => {
    return request({
      url: API.MARKETPLACE.PRODUCTS.GET_ALL,
      method: requestMethods.GET,
    });
  },
  GetBySupplier: (supplierId) => {
    return request({
      url: `${API.MARKETPLACE.PRODUCTS.GET_BY_SUPPLIER}${supplierId}`,
      method: requestMethods.GET,
    });
  },
  GetById: (productId) => {
    return request({
      url: `${API.MARKETPLACE.PRODUCTS.GET_BY_ID}${productId}`,
      method: requestMethods.GET,
    });
  },
};

const Orders = {
  GetAll: () => {
    return request({
      url: API.MARKETPLACE.ORDERS.GET_ALL,
      method: requestMethods.GET,
    });
  },
  GetBySupplier: (supplierId) => {
    return request({
      url: `${API.MARKETPLACE.ORDERS.GET_BY_SUPPLIER}${supplierId}`,
      method: requestMethods.GET,
    });
  },
  GetById: (orderId) => {
    return request({
      url: `${API.MARKETPLACE.ORDERS.GET_BY_ID}${orderId}`,
      method: requestMethods.GET,
    });
  },
};

function getUserById(userId) {
  if (!userId) {
    return Promise.reject(new Error("userId es requerido"));
  }

  return request({
    url: API.USER.GET_USER_BY_ID,
    method: requestMethods.POST,
    data: { id: userId },
  });
}

function getClientAddress(userId) {
  if (!userId) {
    return Promise.reject(new Error("userId es requerido"));
  }

  return getUserById(userId).then((userData) => {
    if (userData && userData.address) {
      return {
        data: {
          address: userData.address,
          success: true,
        },
      };
    }

    return {
      data: {
        address: null,
        success: false,
        message: "No se encontró dirección registrada",
      },
    };
  });
}

function updateClientAddress(userId, addressData) {
  if (!userId) {
    return Promise.reject(new Error("userId es requerido"));
  }

  return request({
    url: API.USER.UPDATE_ADDRESS || "users/address/update",
    method: requestMethods.PUT,
    data: {
      id: userId,
      address: addressData,
    },
  });
}

function getAuthHeaders() {
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token || localStorage.getItem("token");

  return {
    Authorization: token ? `Bearer ${token}` : "",
    "Content-Type": "application/json",
  };
}

// ==================== DHL FUNCTIONS ====================
/**
 * Generar guía de envío DHL
 * @param {Object} payload - Datos para generar la guía
 * @returns {Promise} Respuesta con la guía generada
 */
function generateDHLLabel(payload) {
  return request({
    url: API.MARKETPLACE.DHL.CREATE_SHIPMENT,
    method: requestMethods.POST,
    data: payload,
  }).then((response) => {
    if (response && typeof response.success !== "undefined") {
      return response;
    }

    if (
      response &&
      response.data &&
      typeof response.data.success !== "undefined"
    ) {
      return response.data;
    }

    return response;
  });
}

/**
 * Obtener cotización de envío DHL
 * @param {Object} payload - Datos para cotizar
 * @returns {Promise} Respuesta con la cotización
 */
function getDHLQuote(payload) {
  return request({
    url: API.MARKETPLACE.DHL.QUOTE,
    method: requestMethods.POST,
    data: payload,
  });
}

/**
 * Rastrear envío DHL
 * @param {string} shipmentId - ID del envío o número de guía
 * @returns {Promise} Información de rastreo
 */
function trackDHLShipment(shipmentId) {
  return request({
    url: `${API.MARKETPLACE.DHL.TRACK_SHIPMENT}/${shipmentId}/track`,
    method: requestMethods.POST,
  });
}

/**
 * Actualizar orden con información de envío
 * @param {string} orderId - ID de la orden
 * @param {Object} shippingInfo - Información de envío
 * @returns {Promise} Respuesta de la actualización
 */
function updateOrderShipping(orderId, shippingInfo) {
  return request({
    url: `${API.MARKETPLACE.ORDERS.UPDATE}${orderId}/shipping`,
    method: requestMethods.PATCH,
    data: shippingInfo,
  });
}

const MarketPlaceService = {
  Products,
  Orders,
  createCategory,
  getCategories,
  updateCategory,
  getSubcategoriesByCategory,
  deleteCategoryBySlug,
  newProduct,
  updateProduct,
  deleteProduct,
  getAllProducts,
  getProductById,
  getProductsByCategory,
  getProductsByCategoryAndSubcategory,
  getProductsBySupplier,
  searchProducts,
  filterProducts,
  newOrder,
  updateOrder,
  deleteOrder,
  getOrderById,
  getOrderByClient,
  getOrderBySupplier,
  updateOrderStatus,
  getAllOrders,
  addProductToCart,
  updateCart,
  deleteCart,
  deleteCartProduct,
  getAllCarts,
  getCartByClient,
  getCartById,
  getLogsByOrder,
  addVendor,
  updateVendor,
  archiveVendor,
  unarchiveVendor,
  deleteVendor,
  getAllVendors,
  getAllVendorsByUser,
  getVendorByUser,
  getUserById,
  getClientAddress,
  updateClientAddress,
  getAuthHeaders,
  generateDHLLabel,
  getDHLQuote,
  trackDHLShipment,
  updateOrderShipping,
};

export default MarketPlaceService;
